import React, { useState } from 'react';
import { BaseCardsCarouselProps, BaseCardsCarousel } from './BaseCardsCarousel';

export type CardsCarouselProps = Partial<BaseCardsCarouselProps>;

export const CardsCarousel: React.FC<CardsCarouselProps> = props => {
  const { onSlideIndexChange, ...baseCardsCarouselProps } = props;
  const [ slideIndex, setSlideIndex ] = useState(0);

  const handleSlideIndexChange = (index: number) => {
    setSlideIndex(index);
    if (typeof onSlideIndexChange === 'function') onSlideIndexChange(index);
  };

  return (
    <BaseCardsCarousel
      {...baseCardsCarouselProps}
      slideIndex={slideIndex}
      onSlideIndexChange={handleSlideIndexChange}
    />
  );
};
